var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['resize-column', _vm.class_by_val + '-resize' , { 'active': _vm.hover || _vm.pageX }],on:{"click":function($event){$event.stopPropagation();},"mousedown":_vm.mousedown,"mouseout":_vm.mouseout,"mouseover":_vm.mouseover}})
}
var staticRenderFns = []

export { render, staticRenderFns }